import { css } from '@emotion/react';
import t from 'react-translate';
import { darkGray } from 'athena/styles/colors';
import { CellProps } from './types';
import { commonStyles } from './styles';
import Avatar from '../../avatar';


const NameCell = (props: CellProps) => {
  const { cell, className } = props;

  const value = cell.getValue();
  const { row: { original: { role } } } = cell;

  const styles = css`
    ${commonStyles};

    .picture {
      flex-shrink: 0;
    }

    .right-container {
      flex: 1;
    }

    .email {
      color: ${darkGray};
    }
  `;

  return (
    <div className={`d-flex align-items-center ${className}`} css={styles}>
      <Avatar user={value} role={role?.name} className='picture mr-2' />
      <div className='right-container d-flex flex-column justify-content-center align-items-stretch'>
        <div className='text-medium bold ellipsis'>
          {t.USERS.FULL_NAME(value.firstName, value.lastName)}
        </div>
        <div className='text-small email three-line-ellipsis'>
          {value.email}
        </div>
      </div>
    </div>
  );
};

export default NameCell;
